import {TrackingPageTypeWithId} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import {SharedPageTrackingContextProvider} from '../../../tracking/context/PageTrackingContext';
import TrackContentPageView from '../../../tracking/trackerComponents/TrackContentPageView';
import {LiveShoppingPlayerProvider} from '../context/LiveShoppingPlayerProvider';
import {liveShoppingOverviewPageRoute} from '../routes';
import {LiveShoppingOverview} from '../types';
import {LiveHeader} from './components/LiveHeader/LiveHeader';
import {LiveSections} from './components/LiveSections/LiveSections';

export const LiveShoppingOverviewPage: React.FC<LiveShoppingOverview> = ({
  liveShoppingOverviewPage: {header, sections},
  trackingCustomer,
}) => {
  return (
    <SharedPageTrackingContextProvider
      type={TrackingPageTypeWithId.LiveShopping}
      path={liveShoppingOverviewPageRoute}
      search=""
      id={1}
    >
      <TrackContentPageView trackingCustomer={trackingCustomer ?? null}>
        <div>
          <LiveHeader header={header} />
          <LiveSections sections={sections} />
        </div>
      </TrackContentPageView>
    </SharedPageTrackingContextProvider>
  );
};

const LiveShoppingOverviewPageWrapper: React.FC<
  LiveShoppingOverview
> = props => {
  return (
    <LiveShoppingPlayerProvider>
      <LiveShoppingOverviewPage {...props} />
    </LiveShoppingPlayerProvider>
  );
};

export default LiveShoppingOverviewPageWrapper;
